<script setup lang="ts">
import { Toaster } from '@/components/ui/sonner'
</script>

<template>
    <div>
        <router-view />
        <Toaster position="top-right" :duration="2000" />
    </div>
</template>
